import * as React from 'react'
import { SupportedRuntimesTooltipResolver } from '../../../../../../util/SupportedRuntimesHelper'
import TextField from '@mulesoft/anypoint-components/lib/TextField'
import '../SettingsBodyResourcesList.css'

export type ValueProps = {
  environmentName: string,
  query?: string
}

export type EventProps = {
  onChange: (result: any) => void
}

export type Props = ValueProps & EventProps

export const SettingsBodyResourcesListHeader = (props: Props) => {
  return (
    <div className="settings-body-resources-search-bar-container" data-test-id="settings-body-resources-search-bar-container">
      <div className="settings-body-resources-search-bar-header" data-test-id="settings-body-resources-search-bar-header">
        <span
          className="settings-body-resources-search-bar-header-text"
          data-test-id="settings-body-resources-search-bar-header-text"
        >
          List of resources in {props.environmentName}
        </span>
        <SupportedRuntimesTooltipResolver/>
      </div>
      <TextField
        className="settings-body-resources-search-bar"
        placeholder="Search resource name"
        type="search"
        testId="settings-body-resources-search-bar"
        onChange={props.onChange}
        value={props.query}
      />
    </div>
  )
}
